import React, { Component } from "react";
import { connect } from 'react-redux';
import FileUpload from "components/Upload/FileUpload";
import SimpleReactValidator from 'simple-react-validator';
import ImagePreview from "components/Upload/ImagePreview";
import { Button } from "react-bootstrap";
import Select from 'react-select';
import { toggleModal, openModal, createFormData, focusInput, returnKeyWithColumnMatch, returnLabelsWithValues, closeModalAfterApi, returnLabelWithValue } from 'helper/helperFunctions';
import { storeProShowFile, updateProShowFileCall, getProShowDestinations } from 'redux/actions/proShowFile-action';
import DestinationForm from "components/Admin/Destination/DestinationForm";
import { getDestinations } from 'redux/actions/settings-actions';
import ThemeModal from 'components/ThemeComponents/ThemeModal';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { settingsService } from 'services/settings';
import { getBrands } from "redux/actions/account-action";
import { proShowFileService } from "../../../services/proShowFile";
import { alertActions } from "../../../redux/actions/alert-actions";


class ProShowFormPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pro_show_file: { ...this.props.pro_show_file },
			submitted: false,
			formType: this.props.formType || '',
			pro_show_file_id: this.props.pro_show_file_id,
			addModalDestination: false,/*Modal for destination code*/
			onCloseAfterApi: false,/*Modal for destination code*/
		};
		this.validatorProShowFile = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });

	}
	setResourceFile = (key, value) => {
		this.setState(prevState => {
			if (prevState.formType === 'add') {
				return {
					pro_show_file: {
						...prevState.pro_show_file,
						file: [
							...(prevState.pro_show_file.file || []),
							value
						]
					}
				};
			}

			return {
				pro_show_file: {
					...prevState.pro_show_file,
					file: value
				}
			};
		});
	}
	removeFile = (key, index) => {
		this.setState(prevState => {

			if (prevState.formType === 'add') {
				return {
					pro_show_file: {
						...prevState.pro_show_file,
						file: prevState.pro_show_file.file.filter((_, i) => i !== index)
					}
				};
			}

			return {
				pro_show_file: {
					...prevState.pro_show_file,
					file: null
				}
			};
		});
	};
	handleProShowFileSubmit = (e) => {
		if (this.validatorProShowFile.allValid()) {
			this.setState({ submitted: true }, function () {
				const { formType, pro_show_file } = this.state;
				const fdData = createFormData({
					file: pro_show_file.file,
					replace: formType === 'edit',
					_method: formType === 'edit' ? 'PUT' : 'POST',
				});
				if (formType === 'add') {
					this.props.storeProShowFileCall(fdData).then(
						response => {
							this.props.closeModel();
							this.props.getPagination();
						}
					);
				}
				else if (formType === 'edit') {
					this.props.updateProShowFileCall(fdData, this.props.pro_show_file.id).then(
						response => {
							this.props.closeModel();
							this.props.getPagination();
						}
					);
				}
			});
		} else {
			// console.log('state data', this.state.pro_show_file);
			// console.log('error message', this.validatorProShowFile.getErrorMessages());
			this.setState({ submitted: false });
			focusInput(this.validatorProShowFile.getErrorMessages());
			this.validatorProShowFile.showMessages();
			this.forceUpdate();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.pro_show_file.isDefault && this.state.pro_show_file.isDefault) {
			this.setState(prevState => ({
				pro_show_file: {
					...prevState.pro_show_file,
					destinations: [],
					agencies: Object.keys(this.state.pro_show_file.agencies).length >= 1 ? [this.state.pro_show_file.agencies[0]] : [],
					agency_types: [],
				}
			}));
		}

		/*Modal for destination code*/
		if (!prevState.addModalDestination && this.state.addModalDestination) {
			this.setState({ onCloseAfterApi: false })
		}
		if (prevState.addModalDestination && !this.state.addModalDestination && this.state.onCloseAfterApi) {
			this.props.getDestinationsCall();
		}
		if (prevProps.storedDestination !== this.props.storedDestination) {
			this.setState(prevState => ({
				pro_show_file: {
					...prevState.pro_show_file,
					destinations: [...prevState.pro_show_file.destinations, this.props.storedDestination.id]
				}
			}));
		}
		/*Modal for destination code*/
	}
	render() {

		const { pro_show_file, newDestination } = this.state;
		const { agency_type_id, agenciesOption, ranges, destinations, proShowFileDestination, brands } = this.props;
		const hasFiles =
			this.state.formType === 'add'
				? pro_show_file.file && pro_show_file.file.length > 0
				: !!pro_show_file.file;
		return (
			<div className="row section-Frontend">
				<form>

					<div className="col-md-6 mt-sm" id="File">
						<div className="form-group">
							{this.state.formType !== 'add'
								?
								<p>This will replace the old proshow file.</p>
								:<p></p>
							}
							<div className="row">
								<div className="col-md-12 lbl_container">
									<label htmlFor="name">Upload File<span className="requiredClass">*</span> </label>
								</div>
							</div>
							<span className="customUploader"></span>
							{/* {
								!hasFiles
									? (
										<FileUpload
											setResourceFile={this.setResourceFile}
											multiple={this.state.formType === 'add'}
											allowedFormatsStringMimePro="application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip, text/plain"
											allowedFormatsStringExtPro="zip,psh"
											title="Pro Show File"
											type="pro_show_file"
										/>
									)
									: (
										<ImagePreview
											filesToPreview={pro_show_file.file}
											removeFile={this.removeFile}
										/>
									)
							} */}
							<FileUpload
								setResourceFile={this.setResourceFile}
								multiple={this.state.formType === 'add'}
								allowedFormatsStringMimePro="application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip, text/plain, .psh"
								allowedFormatsStringExtPro="zip,psh"
								title="Pro Show File"
								type="pro_show_file"
							/>

							{
								pro_show_file.file &&
								<ImagePreview
									filesToPreview={pro_show_file.file}
									removeFile={this.removeFile}
								/>
							}
							{
								this.validatorProShowFile.message('File', pro_show_file.file, 'required')
							}
						</div>
					</div>

					<div className="row">
						<div className="col-md-12">
							<div className='text-center'>
								<Button onClick={this.handleProShowFileSubmit} bsSize="large" className="backButton pt-sm no_radius pb-sm success btn btn-lg ml-sm mt-sm btn btn-default" >Save</Button>
								<Button bsSize="large" onClick={() => this.props.closeModel()} className="backButton pt-sm no_radius pb-sm info btn btn-lg btn-info ml-sm mt-sm" >Cancel</Button>
							</div>
						</div>
					</div>
				</form>
				
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		storeProShowFileCall: (data) => { return dispatch(storeProShowFile(data)) },
		updateProShowFileCall: (data, id) => { return dispatch(updateProShowFileCall(data, id)) },
		getDestinationsCall: () => { return dispatch(getDestinations()) },
		getProShowDestinationsCall: () => { return dispatch(getProShowDestinations()) },
        getBrandsCall: () => { dispatch(getBrands()) },
		success: (message) => { return dispatch(alertActions.success(message)) },
		error: (message) => { return dispatch(alertActions.error(message)) },

	});
};
function mapStateToProps(state) {
    const { agenciesOption } = state.agenciesReducer;
    const { proShowFileDestination } = state.proShowFileReducer;
    const { brands } = state.accountReducer;
    // console.log('agenciesOption', agenciesOption);
	const { loadingSettings, agency_type_id, ranges, destinations } = state.settingsReducer;
    const { loadingDestination, storedDestination } = state.destinationsReducer;

	return {
		agenciesOption,
		loadingSettings, agency_type_id, ranges, destinations,
		loadingDestination, storedDestination, proShowFileDestination, brands
	};
}


const ProShowForm = connect(mapStateToProps, mapDispatchToProps)(ProShowFormPage);
export default ProShowForm;
